// ============================================================================
// Configuration du site Hupsoo Conseil
// Tout ce qui doit être modifié sans toucher au code se trouve ici.
// ============================================================================

// --- Formulaire de contact -------------------------------------------------
// Clé d'accès Web3Forms. Tant qu'elle est vide, le formulaire bascule
// automatiquement sur un repli « ouvrir mon logiciel de messagerie » : aucun
// prospect n'est perdu, mais l'envoi n'est pas automatique.
// Pour l'obtenir : https://web3forms.com — saisir hupsooconseil@gmail.com,
// la clé arrive par email. La coller ici, c'est tout.
export const WEB3FORMS_KEY = "06db0780-a330-431c-8154-064e56762680";

// Adresse qui reçoit les demandes et qui est affichée sur le site.
export const CONTACT_EMAIL = "hupsooconseil@gmail.com";
export const CONTACT_PHONE = "07 68 63 88 96";
export const CONTACT_PHONE_INTL = "+33768638896";

// --- Identité juridique ----------------------------------------------------
// « Hupsoo Conseil » est un nom commercial. L'entité qui contracte et facture
// est la société espagnole CGDR CONSULTING S.L.
export const SOCIETE = {
  nomCommercial: "Hupsoo Conseil",
  denomination: "CGDR CONSULTING S.L.",
  forme: "Sociedad de Responsabilidad Limitada",
  capital: "3 000 €",
  adresse: "Calle Tuset 20-24, Planta 8, Puerta 8 — 08006 Barcelone, Espagne",
  nif: "B55460133",
  registre: "Registre du commerce de Barcelone, feuille B-617755",
  zoneIntervention: "Partout en France, à distance",
};

// ⚠️ CHOIX CLIENT DU 31/07/2026 — LES DIRIGEANTS NE SONT PAS NOMMÉS SUR LE SITE.
// Ni dans ce fichier, ni dans App.js, ni sur les pages statiques.
// Formulations à utiliser : « notre consultante », « l'intervenant qui anime nos
// accompagnements », « la direction ».
//
// UNE SEULE EXCEPTION, ET ELLE EST IMPOSÉE PAR LA LOI : le nom du directeur de la
// publication doit figurer dans les mentions légales (art. 6-III-1 de la LCEN).
// Il reste donc nommé dans public/mentions-legales.html, et nulle part ailleurs.
// Ne pas le retirer : l'omission est pénalement sanctionnée (art. 6-VI-2 LCEN).

// --- Formation -------------------------------------------------------------
// IMPORTANT : Hupsoo Conseil n'est PAS un organisme de formation.
// Les actions de formation sont réalisées avec des organismes partenaires
// certifiés Qualiopi, choisis selon le besoin du client. Le site ne doit donc
// afficher NI numéro de déclaration d'activité, NI logo Qualiopi en propre,
// NI référent handicap : ces éléments appartiennent à l'organisme partenaire
// retenu pour chaque mission.
export const INTERVENANT = {
  certification: "RS7344",
  intituleCertification: "Développer son activité avec l'Intelligence Artificielle",
  dateEnregistrement: "27 octobre 2025",
};

// --- Certification « appels d'offres » -------------------------------------
// RS7481, détenue par la consultante qui pilote les réponses aux appels
// d'offres. Le client a choisi de ne PAS la nommer sur le site public.
//
// ⚠️ RÈGLE À NE JAMAIS ENFREINDRE, identique à celle de la RS7344 :
// nous sommes TITULAIRES de la certification, PAS habilités à la délivrer.
//   ✅ « consultante certifiée RS7481 », « certification détenue par notre consultante »
//   ❌ « cabinet certifié », « formation certifiante RS7481 », « éligible CPF »
// Le certificat original (SUPASKILLS, jury du 08/06/2026) n'est pas publié :
// il porte des données personnelles (date et lieu de naissance, signature).
export const CERTIFICATION_AO = {
  code: "RS7481",
  intitule: "Répondre aux appels d'offre de marchés publics",
  repertoire: "Répertoire spécifique de France compétences",
  numeroFiche: "7481",
  codeNSF: "312",
  certificateur: "SUPASKILLS",
  dateEnregistrement: "18 décembre 2025",
  dateObtention: "8 juin 2026",
  urlFiche: "https://www.francecompetences.fr/recherche/rs/7481/",
};

// --- Offre « Recherche de subventions » ------------------------------------
// Ajoutée le 20/08/2026. Modèle arbitré avec le client : forfait de cadrage
// facturé + pourcentage à la réussite, avec un diagnostic gratuit en amont.
//
// ⚠️ La formulation du succès doit rester STRICTEMENT identique à celle des
// quatre cartes « appels d'offres » (« + un pourcentage à la réussite ») :
// une fourchette chiffrée engagerait publiquement le cabinet.
//
// ⚠️ Aucun chiffre de performance sur cette offre (taux de réussite, montants
// obtenus, nombre de dossiers) tant qu'aucun dossier réel n'est documenté.
// Voir les lignes rouges en tête de src/data/subventions.js.
export const OFFRE_SUBVENTIONS = {
  prix: "490 € - 900 € HT",
  periode: "/ cadrage",
  succes: "+ un pourcentage à la réussite",
};

// --- Offre « Qualifications professionnelles » -----------------------------
// Prix arbitrés le 16/09/2026 après benchmark (spec § 2) :
//   700 € = une première demande réellement facturée en juillet 2026.
//   450 € = renouvellement, ~60 % du travail d'une première demande.
//
// ⚠️ DÉCISION CLIENT DU 18/09/2026 (revue finale) : ISO / MASE repassent
// « sur devis ». Le repère à 3 000 € du 16/09 était un bas de fourchette de
// benchmark de marché, pas un prix déjà facturé par le cabinet — contrairement
// au 700 € et au 450 €, adossés à des missions réelles. Le client ne veut pas
// afficher un plancher sur une prestation qu'il n'a jamais vendue : le
// raisonnement du 16/09 est donc périmé pour cette ligne, pas les deux autres.
// ⚠️ Un « à partir de » engage : premiere et renouvellement doivent rester
// réalisables.
// Voir les lignes rouges en tête de src/data/qualifications.js.
export const OFFRE_QUALIFICATIONS = {
  premiere: "à partir de 700 € HT",
  renouvellement: "à partir de 450 € HT",
  systemes: "sur devis",
  mention: "Frais d'instruction de l'organisme en sus, communiqués au diagnostic.",
};

export const estComplet = (valeur) => Boolean(valeur && String(valeur).trim());
